import React from "react";

//   *********************** Footer Section  ****************************//

const Footer = () => {
    return (
        <>
        <footer className="w-100 bg-light text-center">
            <p>All Right Reserved ©2021 Learn_Code</p>
        </footer>
        </>
    )
};
export default Footer;